import { useContext } from 'react'

import { StoreBudgetContext } from '@provider/Budget/storeProvide'

import type { IBudgetStoreContext } from '@base/@types/providers/Budget/store'

export default function useConciliationStoreBudget(): IBudgetStoreContext {
  const context = useContext(StoreBudgetContext)

  return context
}
